import React, { Component } from 'react';
import ComponentTypes from '../../enums/ComponentTypes'
import globalStoreService from '../../services/global-store.service';
import BotType from '../../enums/BotType';

const LoadingResponseComponent = (props) => {
    let { messages } = props;
    let hideLogo = false;

    if (messages && messages.length > 0 && messages[messages.length - 1] && messages[messages.length - 1].component_type === ComponentTypes.DEFAULT) {
        hideLogo = true
    }
    else {
        hideLogo = false
    }

    return (
        <div>
            <span className={(globalStoreService.get("currentBotType") === BotType.PAYMENTS_BANK) ? "arya new paymentsbank" : "arya new"} style={{ visibility: hideLogo ? 'hidden' : 'visible' }}>
                {/* <img src="assets/images/arya.png" /> */}
            </span>
            <ul className="bubbles relate">
                <li style={{ padding: '0px 10px 0px' }}><div className="wave"><span className="dot"></span><span className="dot"></span><span className="dot"></span></div>​</li>
            </ul>
        </div>

    )
}

export { LoadingResponseComponent };



// WEBPACK FOOTER //
// ./src/components/message-components/loading-response.component.js